module.exports = __webpack_public_path__ + "static/media/icons_Bilan quadrant inférieur.a9f58507.svg";